(function() {
    "use strict";
    document.addEventListener('DOMContentLoaded', function () {

        const DEV = 0;

        const stickMeElements = document.querySelectorAll('[stick-me]');

        stickMeElements.forEach(function (element) {
            initializeStickMe(element);
        });

        function initializeStickMe(element) {
            
            var position = {};
            var offset;
            var scrollY;
            var wantedTopStickyPosition = 150;

            DEV && log(element);

            setTimeout(function () {
                // position = relative to parent
                position = element.getBoundingClientRect();
                DEV && log('position', position);

                // offset = relative to window
                offset = element.getBoundingClientRect();
                DEV && log('offset', offset);
            }, 500);

            function stickMe() {
                DEV && log('Sticked !');
                element.style.position = 'fixed';
                element.style.top = wantedTopStickyPosition + 'px';
                element.style.left = offset.left + 'px';
                element.classList.add('sticked');
            }

            function unstickMe() {
                DEV && log('Unsticked !');
                element.style.position = 'relative';
                element.style.left = position.left + 'px';
                element.style.top = 0;
                element.classList.remove('sticked');
            }

            function handleScroll() {
                scrollY = window.pageYOffset || document.documentElement.scrollTop;
                DEV && log('scroll_y', scrollY);
                DEV && log('position.top', position.top);

                if (scrollY > position.top) {
                    stickMe();
                } else {
                    unstickMe();
                }
            }

            window.addEventListener('scroll', handleScroll);
        }
        
    });
})();